import React, { Component } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Validators from '../../utils/Validators';
import { connect } from 'react-redux';
import { showError } from '../../actions/uiActions';
import Select from 'react-select';
import Creatable from 'react-select/creatable';
import DomainApi from "../../api/domains"
class AuthorizedOfficial extends Component {
  state = {
    employer_name: '',
    employer_official_name: '',
    employer_official_phone: '',
    employer_official_email: '',
    employer_fein: '',
    employer_website: "",
    official_title:"",
    companies: [],
    employers: [],
    selectedOption: null,
    notes: ''
  };

  componentDidMount = async () => {
    try {
      const data = await DomainApi.getEmployers()
      data.sort((first, second) => {
        if (first.company.toLowerCase() < second.company.toLowerCase()) {
          return -1;
        }
        if (first.company.toLowerCase() >= second.company.toLowerCase()) {
          return 1;
        }
      });
      this.setState({ employers: data, notes: this.props.note })
    } catch (error) {
      this.props.showError();
    }
  }

  handleInputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  confirm = () => {
    if (!this.state.employer_name)
      this.props.showError('You must enter the name of the employer');
    else if (!this.state.employer_official_name)
      this.props.showError('You must enter the name of an authorized official');
    else if (!Validators.isValidPhone(this.state.employer_official_phone))
      this.props.showError(
        'You must enter the phone number of the authorized official'
      );
    else if (!Validators.isValidEmail(this.state.employer_official_email)) {
      this.props.showError(
        'You must enter the email address of the authorized official.'
      );
    }
    else {
      let payload = {
        employer_name: this.state.employer_name,
        employer_official_name: this.state.employer_official_name,
        employer_official_phone: this.state.employer_official_phone,
        employer_official_email: this.state.employer_official_email,
        employer_fein: this.state.employer_fein,
        employer_website: this.state.employer_website,
        official_title: this.state.official_title,
        domainId: this.state.selectedCompany?.value || this.state.employer_name
      }
      if (this.state.selectedCompany) {
        payload = {
          ...payload,
          domainId: this.state.selectedCompany.value
        }
      }
      this.props.onConfirm(this.state.notes, payload);
    }
  };
  handleCompanySelect = (selectedCompany) => {
    this.setState({ selectedCompany }, () => {
      if (selectedCompany !== null && !this.getEntityOptions()) {
        this.state.employers.filter((e) => e._id === selectedCompany.value && this.setState({
          employer_official_name: e.official_name && e.official_name !== "Name" && e.official_name !== "Type Name" ? e.official_name : "",
          employer_official_phone: e.official_phone ? e.official_phone : "",
          employer_official_email: e.official_email ? e.official_email : "",
          employer_name: e.company,
          employer_fein: e.employer_fein,
          employer_website: e?.employer_website,
          official_title: e?.official_title,
          prefilled: true,
          selectedEntity: null
        }))
      } else {
        this.setState({
          employer_official_name: "",
          employer_official_phone: "",
          employer_official_email: "",
          employer_name: "",
          prefilled: false,
          notes: "",
          employer_fein: "",
          employer_website: "",
          official_title:"",
          selectedEntity: null
        })
      }
    });
  };
  getCompanyOptions = () => {
    if (!this.state.employers.length) {
      return []
    }
    return this.state.employers.map((eachCompany) => ({
      value: eachCompany._id,
      label: eachCompany.company
    }))
  }
  handleOnInputChange = (value) => {
    if (value) this.setState({ selectedOption: { value, label: value }, employer_name: value });
  };

  getEntityOptions = () => {
    if (!this.state.selectedCompany) {
      return null
    }
    const company = this.state.employers.find(each => each._id === this.state.selectedCompany.value)
    if (!company || !(company.entities || []).length) {
      return null
    }
    return company.entities.map(each => ({
      value: each.id,
      label: `${each.employer_name} (${each.employer_fein})`
    }));
  }

  handleEntitySelect = (selectedEntity) => {
    if (!selectedEntity.value) {
      return
    }
    const company = this.state.employers.find(each => each._id === this.state.selectedCompany.value)
    let entity;
    if (company._id === selectedEntity.value) {
      entity = company;
    } else {
      entity = company.entities.find(each => each.id === selectedEntity.value);
    }
    this.setState({
      employer_official_name: entity.official_name && entity.official_name !== "Name" && entity.official_name !== "Type Name" ? entity.official_name : "",
      employer_official_phone: entity.official_phone ? entity.official_phone : "",
      employer_official_email: entity.official_email ? entity.official_email : "",
      employer_name: entity.employer_name,
      employer_fein: entity.employer_fein,
      employer_website: entity?.employer_website || "",
      official_title: entity?.official_title || "",
      prefilled: true,
      selectedEntity,
    })
  }

  render() {
    return (
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        open={true}
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">Employer Information</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p>
              Use the form below to enter the information of the user Employer's
              Authorized Official that will sign this form.
            </p>

            <div className="row">
              <div className="col-12">
                <div className="form-group nice">
                  <label>Employer Name:</label>
                  <Creatable
                    placeholder="Name of the Employer"
                    value={this.state.selectedCompany}
                    onChange={this.handleCompanySelect}
                    isClearable
                    isLoading={this.state.employers.length > 0 ? false : true}
                    options={this.getCompanyOptions()}
                    onInputChange={this.handleOnInputChange}
                    isSearchable
                    closeMenuOnSelect
                    closeMenuOnScroll
                  />
                  
                </div>
              </div>
              {
                this.getEntityOptions() ? <div className="col-12">
                  <div className="form-group nice">
                    <label>Entity:</label>
                    <Select
                      placeholder="Select the entity"
                      value={this.state.selectedEntity}
                      onChange={this.handleEntitySelect}
                      options={this.getEntityOptions()}
                    />
                  </div>
                </div> : ""
              }
              <div className="col-12">
                <div className="form-group nice">
                  <label>Authorized Official:</label>
                  <input
                    type="text"
                    placeholder="Authorized Official's Name"
                    className="form-control"
                    value={this.state.employer_official_name}
                    onChange={this.handleInputChange}
                    name="employer_official_name"
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="form-group nice">
                  <label>Authorized Official Email Address:</label>
                  <input
                    type="email"
                    placeholder="Authorized Official's Email"
                    className="form-control"
                    value={this.state.employer_official_email}
                    onChange={this.handleInputChange}
                    name="employer_official_email"
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="form-group nice">
                  <label>Authorized Official Phone Number:</label>
                  <input
                    type="tel"
                    placeholder="Authorized Official's Phone"
                    className="form-control"
                    value={this.state.employer_official_phone}
                    onChange={this.handleInputChange}
                    name="employer_official_phone"
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="form-group nice">
                  <label>Message:</label>
                  <textarea type="text" col="4" placeholder={`Enter any additional notes for the Authorized Official (e.g. "Please certify my employment with Company ABC from Dec 2019 to February 2021" )`} className="form-control" value={this.state.notes} onChange={this.handleInputChange} name="notes" />
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={this.confirm}
            color="primary"
            autoFocus
          >
            Assign Official
          </Button>
          <Button onClick={this.props.onCancel} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default connect(null, { showError })(AuthorizedOfficial);
